import { render } from "./InstitutionReview.vue?vue&type=template&id=1033ab7b&lang=pug"
import script from "./InstitutionReview.vue?vue&type=script&lang=js"
export * from "./InstitutionReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__